import { render, staticRenderFns } from "./todopage.vue?vue&type=template&id=b41e6a34&scoped=true&"
import script from "./todopage.vue?vue&type=script&lang=js&"
export * from "./todopage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41e6a34",
  null
  
)

export default component.exports